

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { setResultModalData, showModal } from "../modal/modalSlice";
import axiosInstance from "../../axios/axiosInstance";

const initialState = {

  isletmeList:[],
  isLoadingGetYellowPagesData: false,

  selectedIsletmeItem: null,
  
  isletmeImages: null,
  isLoadingGetYellowPagesImages: false,

  yellowPageLocation: null

}

export const getYellowPagesData = createAsyncThunk("yellowPages/getYellowPagesData", async({keyWord, location}, thunkApi)=> {
        let radius = 40 * 1000;
        try {
           
          const postData = {
            includedTypes: [keyWord],
            rankPreference : "distance",
            maxResultCount: 20,
         
            locationRestriction: {
              circle: {
                center: {
                  latitude: location.lat,
                  longitude: location.lng
                },
                radius: radius
              }
            }
          };

        const { data } = await axios.post(
            'https://places.googleapis.com/v1/places:searchNearby' , postData, {
              headers: {
                'Content-Type': 'application/json',
                'X-Goog-Api-Key': process.env.REACT_APP_GOOGLE_API_KEY,
                'X-Goog-FieldMask': '*'
              }
            })
    
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})


export const getYellowPagesImages = createAsyncThunk("yellowPages/getYellowPagesImages", async(isletmeItem, thunkApi)=> {
  try {
  const { data } = await axios.get(
      `https://places.googleapis.com/v1/${isletmeItem.photos[0].name}/media?maxHeightPx=400&maxWidthPx=400&key=${process.env.REACT_APP_GOOGLE_API_KEY}` , {
        headers: {
          'Content-Type': 'application/json',
        }
      })
    return data
} catch (error) {
  return thunkApi.rejectWithValue(error)
}
})


export const getDetailPlace = createAsyncThunk(
  'yellowPages/getDetailPlace',
  async (placeId, thunkApi) => {
    try {
      const { data } = await axios.get(
        'https://places.googleapis.com/v1/places/' +
"ChIJD7fb2ge6sBQRgz5OIPKK3LY" +
          '?fields=id,displayName,photos' +
          '&key=AIzaSyCUpgSRc6nfn1edNGaSSLSOx6Sa9H1942s'
      );
      return data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);




const yellowPagesSlice = createSlice({
    name: "yellowPages",
    initialState,
    reducers: {

      setYellowPageLocation: (state, action) => {
        state.yellowPageLocation = action.payload
      },

      setSelectedIsletmeItem: (state,action) => {
        state.selectedIsletmeItem = action.payload
      },

      clearYellowPagesData: (state ,action) => {
        state.isletmeList = []
        // state.yellowPageLocation = null
      }

    },
    
    extraReducers:(builder)=> {
        builder

        // //! getYellowPagesData
        .addCase(getYellowPagesData.pending, (state)=> {
            state.isLoadingGetYellowPagesData = true
        })

        .addCase(getYellowPagesData.fulfilled, (state, action)=> {
            state.isLoadingGetYellowPagesData = false
            state.isletmeList = action.payload.places
        })

        .addCase(getYellowPagesData.rejected, (state, action)=> {
            state.isLoadingGetYellowPagesData = false
        })

          // //! getYellowPagesData
          .addCase(getYellowPagesImages.pending, (state)=> {
            state.isLoadingGetYellowPagesImages = true
        })

        .addCase(getYellowPagesImages.fulfilled, (state, action)=> {
            state.isLoadingGetYellowPagesImages = false
            state.isletmeImages = action.payload
        })

        .addCase(getYellowPagesImages.rejected, (state, action)=> {
            state.isLoadingGetYellowPagesImages = false
        })

    }
})


export const {setYellowPageLocation, setSelectedIsletmeItem, clearYellowPagesData} = yellowPagesSlice.actions
export default yellowPagesSlice.reducer
